import { urlSeccion as urlSeccionFn } from './shared/secciones';
import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GooglesheetService } from './services/googlesheet.service';
import { DolarService } from './services/dolar.service';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  urlSeccion = urlSeccionFn;

  constructor(
    private googleSheet: GooglesheetService,
    private dolarService: DolarService,
    private router: Router,
    private analytics: AnalyticsService,
  ) {}
  hojas: string[] = [];
  dolarBlueFormateado: string = '';
  // /admin y la herramienta de IG (/ig) tienen layout propio — no llevan el
  // header/footer del sitio público.
  sinLayoutPublico = this.esRutaHerramienta(this.router.url);

  private esRutaHerramienta(url: string): boolean {
    return url.startsWith('/admin') || url.startsWith('/ig') || url.startsWith('/cuotas');
  }

  // Incremento que se suma al dólar blue "venta" para mostrar la cotización
  // pública. Sale de Configuración (CRM); 15 es el valor histórico.
  private incrementoDolar = 15;

  ngOnInit(): void {
    this.analytics.iniciar();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd)
        this.sinLayoutPublico = this.esRutaHerramienta(event.urlAfterRedirects);
    });

    this.googleSheet.cargarHojas(); // se hace una sola vez
    this.googleSheet.hojas$.subscribe((data) => {
      this.hojas = data;
    });

    this.googleSheet
      .getSheetData('Configuraciones!B3:B3', 'config')
      .subscribe({
        next: (data) => {
          const incremento = Number(data?.values?.[0]?.[0]);
          if (Number.isFinite(incremento)) this.incrementoDolar = incremento;
          this.cargarDolar();
        },
        error: () => this.cargarDolar(),
      });
  }

  private cargarDolar(): void {
    this.dolarService.getDolarBlue().subscribe({
      next: (dolar) => {
        const cotizacion = Number(dolar.venta) + this.incrementoDolar;
        this.dolarBlueFormateado = cotizacion.toLocaleString('es-AR', {
          minimumFractionDigits: 0,
        });
      },
      error: (error) => {
        console.error('No se pudo obtener la cotización del dólar', error);
      },
    });
  }
}
